export const IS_INTERNAL_PREVIEW =
  typeof window !== 'undefined' && String(window.location.href).indexOf('ft_internal_open') > -1
